import React from 'react';
import {Modal} from './index';

/*
 Displays a List of buttons
 Accepts a message and an optionsList containing labels and actions.
 */

export const ActionSheetModal = (props) => {
  const {isOpen, onClose, optionsList, showCancel = true, title, message, ...extraProps} = props;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="EviteModal__Content ActionSheetModal"
      {...extraProps}
    >
      <ol className="ActionSheetModal__list">
        {!!title && <li className="ActionSheetModal__message__title">{title}</li>}
        {!!message && <li className="ActionSheetModal__message__message">{message}</li>}
        {optionsList.map((item) => (
          <li
            key={item.label}
            onClick={() => {
              item.action();
              onClose();
            }}
            className={`ActionSheetModal__action ActionSheetModal__action${
              item.destructive && '__destructive'
            }`}
          >
            {item.label}
          </li>
        ))}
      </ol>
      {showCancel && (
        <ol className="ActionSheetModal__list">
          <li className="ActionSheetModal__cancel" onClick={onClose}>
            Cancel
          </li>
        </ol>
      )}
    </Modal>
  );
};
